import * as React from 'react';
import Link from 'next/link';
import { useTranslation } from 'react-i18next';
import Paginator from '@/components/ui/Paginator';
import LayoutSplit from '@/components/ui/LayoutSplit';
import { DownloadResults } from '@/components/content/MarketingListTool/DownloadResults';
import { InfopankCompanySearchResponseDto } from '@/apiTypes/types';
import { getInternalLink } from '@/lib/helpers/getInternalLink';
import { MARKETING_MAX_ITEMS } from '@/lib/constants';
import { Locale } from '@/lib/enums/locale.enum';
import { IMarketingListToolFilter } from '@/components/content/MarketingListTool/interfaces/marketingListToolFilter.interface';
import { User } from '@/components/auth/AuthProvider';

interface IProps {
  data: InfopankCompanySearchResponseDto;
  setCurrentPage: (value: number) => void;
  filter: IMarketingListToolFilter;
  user: User | null;
  isTotalLoaded: boolean;
}

export const CompanyResults = (props: IProps) => {
  const total = props.data.meta.total < MARKETING_MAX_ITEMS ? props.data.meta.total : MARKETING_MAX_ITEMS;
  const numberOfPages = Math.ceil(total / props.data.meta.pageSize);
  const { t, i18n } = useTranslation();
  return (
    <LayoutSplit layout="filter">
      <div>
        <table className="wrappable">
          <thead>
            <tr>
              <th>{t('components.search.companyName')}</th>
              <th className="align-right">{t('components.search.registrationCode')}</th>
            </tr>
          </thead>
          <tbody>
            {(props.data.items || []).map((c, i) => {
              return (
                <tr key={i}>
                  <td>
                    <Link
                      target="_blank"
                      href={getInternalLink('Company', c.id, i18n.language as Locale, c.name)}
                      draggable={false}
                      prefetch={false}
                    >
                      {c.name}
                    </Link>{' '}
                  </td>
                  <td
                    data-label={t('components.search.registrationCode')}
                    className="align-right label-secondary"
                  >
                    {c.regNr}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
        <Paginator
          numberOfPages={numberOfPages}
          currentPage={props.data.meta.pageNumber + 1}
          onPageChange={({ selected }) => props.setCurrentPage(selected)}
        />
      </div>
      <DownloadResults
        total={props.data.meta.total}
        filter={props.filter}
        type={'Company'}
        user={props.user}
        isTotalLoaded={props.isTotalLoaded}
      />
    </LayoutSplit>
  );
};
